<app-title-bar rootBreadCrumbs="['i18n.core.navigation.export-configuration']" titleText="i18n.core.navigation.fieldAssignmentTemplates"></app-title-bar>
<div>
  <div class="row grow w-100">
    <div class="col-4 d-flex justify-content-between">
      <span>
        {{'i18n.domain.export-configuration.field-assignment-templates.overview.header' | translate }}
      </span>
      <span class="e-icons icon-add e-icon-big"
        title="{{ 'i18n.domain.export-configuration.field-assignment-templates.overview.add-button-tooltip' | translate }}"
        (click)="addTemplate()">
      </span>
    </div>
  </div>
  <div class="row grow w-100">
    <div class="col-4">
      <app-field-assignment-templates-overview (rowSelected)="templateSelected($event)" [templateForm]="templateForm" [isStandalone]="true" [selectedTemplateId]="selectedTemplateId">
      </app-field-assignment-templates-overview>
    </div>
    <div class="col-8 h-100 right" [hidden]="!template">
      <div class="e-card">
        <div class="e-card-content h-100">
          <app-field-assignment-template-form [templateForm]="templateForm"></app-field-assignment-template-form>
        </div>
        <div class="e-card-actions">
          <div class="d-flex">
            <div class="btn-group me-auto">
              @if (template) {
                <button type="button" (click)="deleteTemplate()" class="btn btn-outline-danger me-2 btn-fixedw rounded">
                  <span class="e-icons icon-erase danger me-2"></span>
                  {{ 'i18n.domain.export-configuration.shared.buttons.delete' | translate }}
                </button>
              }
            </div>
            <div class="btn-group ms-auto">
              <button type="reset" (click)="closeTemplate()" class="btn btn-outline-secondary me-2 btn-fixedw rounded">
                {{ 'i18n.domain.export-configuration.shared.buttons.discard' | translate }}
              </button>
              <button type="submit" (click)="saveTemplate()" class="btn btn-outline-primary me-2 btn-fixedw rounded">
                {{ 'i18n.domain.export-configuration.shared.buttons.save' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
